import { useState } from 'react';

import { useDraftInvoices, useSendInvoiceBatch } from '../hooks';

/**
 * Alle concepten in één keer versturen. De knop staat in de kop van het scherm,
 * de bevestiging en de uitkomst op het tabblad Facturen aan klanten; daarom houdt
 * het scherm deze stand vast en geeft hij hem aan dat tabblad door.
 *
 * De concepten worden alleen opgevraagd als `enabled`: voor de eigenaar, op dat
 * tabblad.
 */
export function useInvoiceBatch(enabled: boolean) {
    const drafts = useDraftInvoices(enabled);
    const sendBatch = useSendInvoiceBatch();
    const [confirming, setConfirming] = useState(false);
    const [labels, setLabels] = useState<ReadonlyMap<string, string>>(new Map());
    const [dismissed, setDismissed] = useState(false);

    const draftItems = drafts.data?.items ?? [];

    function send(invoiceUuids: string[], nextLabels: ReadonlyMap<string, string>) {
        setLabels(nextLabels);
        setDismissed(false);
        setConfirming(false);
        sendBatch.mutate(invoiceUuids);
    }

    return {
        draftItems,
        draftTotal: drafts.data?.meta?.total ?? draftItems.length,
        sendBatch,
        confirming,
        setConfirming,
        labels,
        dismissed,
        setDismissed,
        send,
    };
}

export type InvoiceBatch = ReturnType<typeof useInvoiceBatch>;
